import React, { useState } from "react";
import Header from "../../../Components/HeaderAdmin/Header";
import { Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import { buildStAdd } from "../../../Api/buildST";

function StationAdd() {

    const [pageStage, setPageStage] = useState("view");
    const [station_name, setStation_name] = useState('');
    const [stationId, setStationId] = useState('');

    const handleEditView = () => {
        pageStage === "view" ? setPageStage("edit") : setPageStage("view");
    }
    const handleAddbuildST = () => {
        const data = {
            build_Stations_name: station_name,
            build_Stations_id: stationId
        }
        buildStAdd(data).then((res) => {
            // console.log("ddddddddd",res)
            if (res?.code === 200) {
                const Data = res.data.data;
                alert("Station details Add successfully.");
                setStation_name("");
                setStationId("");
            } else {
                alert(res.data?.message);
            }
        }).catch((err) => {
            alert("Error occurred: " + err);
            console.error("Error:", err);
        });
    }

    return (
        <>
            <div className="main-page-body-content-header">
                <Header />
            </div>
            <div className="dashboard-container d-flex">
                <div className="main-container">
                    <div className="main-page-body-content">
                        <div className="main-page-body-content-body">
                            <div className="main-page-body-content-body-container">
                                <div className="container-fluid">
                                    <div className="sec-header-dash">
                                        <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                            <h3>Station Add</h3>
                                        </div>
                                    </div>
                                    <div className="dashboard-sec">
                                        <div className="container-fulid">
                                            <Form >
                                                {/* <fieldset disabled={pageStage === "view" ? true : false}> */}
                                                <div className="form-box-section mt-4">
                                                    <div className="form-box-inner">
                                                        <div className="form-item">
                                                            <div className="form-group custom-form-group">
                                                                <div className="col-md-6">
                                                                    <label className="dashboard-form-lable">Station ID</label>
                                                                </div>
                                                                <input
                                                                    type="text"
                                                                    placeholder="Id"
                                                                    required
                                                                    className={`form-control dashboard-input-box-1 me-1 w-100`}
                                                                    value={stationId}
                                                                    onChange={(e) => setStationId(e.target.value)}

                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="form-item">
                                                            <div className="form-group custom-form-group mb-0">
                                                                <div className="col-md-6">
                                                                    <label className="dashboard-form-lable">Station Name</label>
                                                                </div>
                                                                <input
                                                                    type="text"
                                                                    placeholder="station_name"
                                                                    required
                                                                    className={`form-control dashboard-input-box-1 me-1`}
                                                                    value={station_name}
                                                                    onChange={(e) => setStation_name(e.target.value)}
                                                                />
                                                                {/* <input
                                                                        type="text"
                                                                        required
                                                                        className={`form-control dashboard-input-box-1 me-1`}
                                                                        placeholder="Last"
                                                                        name={"lastname"}
                                                                    /> */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* </fieldset> */}

                                            </Form>
                                            <div className="sec-btn-group mt-4">
                                                <div></div>
                                                <button className="btn btn-save" type="submit" onClick={handleAddbuildST}>Save</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default StationAdd;